import styles from '@/styles/components/common/Collapser.module.scss'
import { useRef, useState } from 'react'

interface Props {
  bgColor: string,
  height?: number,
  offset?: number,
  removePadding?: boolean
}

export const Collapser: React.FC<Props> = ({ children, bgColor, height = 260, removePadding = false, offset = 0 }) => {
  const [active, setActive] =  useState(false)
  const [ heightState, setHeight ] = useState(height)
  const ref = useRef<HTMLDivElement>(null)

  const linkText = () => {
    return active ? 'Show less' : 'Show more'
  }

  return (
    <div
      className={`${styles.collapser} ${active ? styles.collapser_active : ''}`}
      style={{'backgroundColor': bgColor, height: `${heightState}px`, padding: `${removePadding ? '0' : undefined}` }}
      ref={ref}

    >
      <div className={styles.collapser_content}>
        {children}
      </div>
      <div className={styles.collapser_show_more} style={{backgroundImage: `linear-gradient(0deg, ${ bgColor || '#fff6e1' } 80%, rgba(255, 246, 225, 0.001) 100%)`, paddingLeft: `${removePadding ? '0' : undefined}` }}>
        <span className="link" onClick={() => {
          if (active) {
            setHeight(height)
          } else {
            if (ref.current) {
              setHeight(ref.current.scrollHeight + offset)
            }
          }

          setActive(!active)
        }}>{ linkText() }</span>
      </div>
    </div>
  )
}
